import React, { FC, createContext, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import {
  INetworkName,
  IProviderName,
  INetworkConfig,
  NETWORKS,
  PROVIDERS,
  NETWORK_NAME_DEFAULT,
  PROVIDER_NAME_DEFAULT,
} from '@shared/constants'

import routerActions from '../store/modules/router'
import snackbarActions from '../store/modules/snackbar'
import withProviderName from '../hooks/withProviderName'
import withNetworkName from '../hooks/withNetworkName'
import withNetwork from '../hooks/withNetwork'

export interface IEthContext {
  network: INetworkConfig,
  networkName: INetworkName,
  providerName: IProviderName,
  setNetwork: {
    (network: INetworkName): void,
  },
  setProvider: {
    (provider: IProviderName): void,
  },
}

export const EthContext = createContext<IEthContext>({
  network: NETWORKS[NETWORK_NAME_DEFAULT],
  networkName: NETWORK_NAME_DEFAULT,
  providerName: PROVIDER_NAME_DEFAULT,
  setNetwork: () => {},
  setProvider: () => {},
})

export const EthProvider: FC = ({
  children,
}) => {

  const dispatch = useDispatch()

  const providerName = withProviderName()
  const networkName = withNetworkName()
  const network = withNetwork()
  
  const setNetwork = useCallback((network: INetworkName) => {
    dispatch(routerActions.mergeQueryParams({
      network,
    }))
    dispatch(snackbarActions.setSuccess(`network changed to: ${NETWORKS[network].title}`))
  }, [])

  const setProvider = useCallback((provider: IProviderName) => {
    dispatch(routerActions.mergeQueryParams({
      provider,
    }))
    dispatch(snackbarActions.setSuccess(`provider changed to: ${PROVIDERS[provider].title}`))
  }, [])

  return (
    <EthContext.Provider value={{
      networkName,
      providerName,
      network,
      setNetwork,
      setProvider,
    }}>
      { children }
    </EthContext.Provider>
  )
}

export default EthContext